import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CollegaModalPageRoutingModule } from './collega-modal-routing.module';

import { CollegaModalPage } from './collega-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CollegaModalPageRoutingModule
  ],
  declarations: [CollegaModalPage]
})
export class CollegaModalPageModule {}
